export default __webpack_public_path__ + "assets/images/caf4f241366596955d790044398292c0.png";